module.exports = __webpack_public_path__ + "static/noise-0830c85087e7b4b9eb3f3e943dfc681b.png";